import React, { useMemo } from 'react'
import { StepperContainer, Step } from './styles'

type SignUpStepperProps = {
    size: number
    currentValue: number
}

export const SignUpStepper = ({ currentValue, size }: SignUpStepperProps) => {
    const items = useMemo(() => Array.from(Array(size).keys()), [size])

    return (
        <StepperContainer>
            {items.map((el, i) => (
                <Step className={currentValue === i ? 'active' : ''} data-testid="step" key={el} />
            ))}
        </StepperContainer>
    )
}
